import script from "./Ad1Molecule.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad1Molecule.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__